import React, { useEffect, useState } from "react";
import { db } from "../database/firebase";
import { doc, getDoc } from "firebase/firestore";
import Modal from "../component/Modal";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import logo from "../assets/logocolor.svg";
import Footer from "../component/Footer";
import clases2 from "../assets/resultado2.jpeg";

const Clases2 = () => {
  const [clase, setClase] = useState(null);
  const [modalLink, setModalLink] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const openModalWithLink = (link) => {
    setModalLink(link);
    toggleModal();
  };

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, "clases", "claseRealtime");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setClase(docSnap.data());
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error obteniendo el documento:", error);
      }
    };
    fetchData();
  }, []);

  console.log(clase === null ? "Cargando..." : clase);

  return (
    <div class="main">
      <FloatingWhatsApp
        phoneNumber="+5492236879502" // El número de teléfono al que se enviará el mensaje
        accountName="Rentable Inversor" // El nombre de la empresa o persona que ofrece el servicio
        statusMessage="Te responderé en menos de 24 horas" // El texto que indica el tiempo de respuesta
        chatMessage="Hola 👋 ¿te puedo ayudar en algo?" // El mensaje predeterminado que se mostrará en el chat
        placeholder="Escribe un mensaje" // El texto del campo de entrada
        darkMode={false} // El modo oscuro del botón y el chat
        avatar={logo} // La imagen del avatar
        chatboxStyle={{ boxShadow: "0 4px 8px rgba(0,0,0,0.2)" }} // El estilo del chat
      />
      <div class="main_platform_block mt-[50px] mx-auto flex flex-col sm:flex-row justify-center max-w-[1240px]">
        <div class="main_platform_image p-2">
        <img
            alt="platform"
            class="main_image max-w-auto h-auto sm:max-w-[580px] sm:max-h-[580px] sm:h-[580px] top-[-25px] lg:left-[-100px] xl:left-[-150px] rounded-2xl object-scale-down shadow-2xl shadow-black/60"
            src={clases2}
          />
          <div class="flex justify-center text-[24px] font-bold leading-[24px] mt-[10px] bg-gray-700 rounded-2xl mx-auto px-4 py-2">
            {clase?.cupos === "0" ? (
              <span class="text-red-500 font-bold text-[32px]">
                Cupos agotados
              </span>
            ) : clase?.cupos ? (
              <span class="text-white">Cupos restantes: {clase.cupos}</span>
            ) : (
              <span class="text-white">Cargando...</span>
            )}
          </div>
        </div>
        <div class="main_platform_container flex flex-col max-w-full sm:max-w-[620px] w-full md:pl-[90px] pl-2">
          <h1 class="main_text font-bold text-white md:text-[20px] lg:text-[20px] xl:text-[32px] 2xl:text-[32px] mb-[6px] mr-[24px] leading-[56px] tracking-tight whitespace-pre-line break-words">
            {clase?.titulo}
          </h1>
          <span class="main_subtext text-white/60 md:text-[14px] lg:text-[14px] xl:text-[16px] 2xl:text-[16px] leading-[24px] mr-[24px] mb-[4px] whitespace-pre-line break-words">
            {clase?.descripcion}
          </span>
          <div class="flex items-center space-x-2 mb-10">
            <h1 class="precio_curso main_text font-bold text-white md:text-[20px] lg:text-[20px] xl:text-[24px] 2xl:text-[20px] mr-[18px] leading-[56px] tracking-tight antialiased">
              ${clase?.precio}
            </h1>
            <span class="text-white"> {clase?.moneda} </span>
          </div>
          <div class="flex flex-col space-y-5 mx-auto md:mx-0">
            {clase?.link_binance && (
              <div>
                <button
                  onClick={() => openModalWithLink(clase.link_binance)}
                  class="btn bg-btnyellow rounded-[4px] p-18 text-white hover:text-btnyellow font-bold ml-auto py-4 px-14 shadow-btn-shadow shadow-btnyellow/25 w-full hover:bg-[#ffffff] hover:shadow-btn-shadow hover:shadow-[#ffffff] transition duration-300 ease-in-out"
                  disabled={clase?.cupos === "0"}
                >
                  Pagar con BINANCE
                </button>
              </div>
            )}
            {clase?.link_mp && (
              <div>
                <button
                  onClick={() => openModalWithLink(clase.link_mp)}
                  class="btn bg-btnblue rounded-[4px] p-18 text-white hover:text-btnblue font-bold ml-auto py-4 px-14 shadow-btn-shadow shadow-btnblue/25 w-full hover:bg-[#ffffff] hover:shadow-btn-shadow hover:shadow-[#ffffff] transition duration-300 ease-in-out"
                  disabled={clase?.cupos === "0"}
                >
                  Pagar con Mercado Pago
                </button>
              </div>
            )}
            {clase?.link_hotmart && (
              <div>
                <button
                  onClick={() => openModalWithLink(clase.link_hotmart)}
                  class="btn bg-btngray rounded-[4px] p-18 text-white hover:text-btngray font-bold ml-auto py-4 px-14 shadow-btn-shadow shadow-btngray/25 w-full hover:bg-[#ffffff] hover:shadow-btn-shadow hover:shadow-[#ffffff] transition duration-300 ease-in-out"
                  disabled={clase?.cupos === "0"}
                >
                  Pagar con Debito / Credito
                </button>
              </div>
            )}
          </div>
          <Modal
            isOpen={isOpen}
            toggleModal={toggleModal}
            link={modalLink}
          ></Modal>
          <div class="flex flex-col md:flex-row mx-auto md:mx-0">
            <iframe
              class="w-[320px] h-[260px] shadow-[2px_4px_4px_rgb(0_0_0_/_25%)] flex justify-center border rounded-[10px] border-solid border-[#bcbcbc] mt-5"
              src="https://dolarhoy.com/i/cotizaciones/dolar-blue"
              title="Dolar Blue"
              frameborder="0"
            ></iframe>
            <div>
              <button
                class="ml-4 mt-4 text-white text-[14px] leading-[24px] font-[400] hover:underline"
                onClick={() => openModalWithLink("Transferencia")}
                disabled={clase?.cupos === "0"}
              >
                ¿Deseas abonar mediante transferencia bancaria?
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center mt-10 w-full">
        <div class="contenido_item bg-black/10 p-4 rounded-lg w-full max-w-[1240px]">
          <h3 class="text-2xl font-bold text-white mb-4">
            Contenido de clases 1 a 1
          </h3>
          <div class="flex flex-col text-gray-400 list-disc list-inside">
            <span>
              <span class="font-bold">+15 Clases:</span> Más de 15 clases en
              vídeo donde profundizarás en temas más avanzados sobre las
              opciones binarias, como el análisis técnico, el análisis
              fundamental, los indicadores, los patrones, etc. ✅
            </span>
            <span>
              <span class="font-bold">
                Estrategias Privadas y Únicas (%93):
              </span>{" "}
              Algunas estrategias de trading que supuestamente tienen un 93% de
              efectividad, es decir, que aciertan casi todas las veces. Estas
              estrategias son exclusivas de este curso y no las encontrarás en
              ningún otro lugar. ✅
            </span>
            <span>
              <span class="font-bold">Análisis en VIVO (Directos):</span> Acceso
              a sesiones en vivo donde podrás ver cómo operan los expertos,
              hacerles preguntas, seguir sus consejos y copiar sus operaciones.
              (Directos) ✅
            </span>
            <span>
              <span class="font-bold">Conceptos avanzados en Binarias:</span>{" "}
              Aprenderás conceptos avanzados sobre las opciones binarias, como
              el hedging, el rollover, el cierre anticipado, el doble toque, el
              escalera, etc. ✅
            </span>
            <span>
              <span class="font-bold">Mejores plataformas de cambio:</span>{" "}
              Conocerás las mejores plataformas de cambio donde podrás
              intercambiar tus ganancias en opciones binarias por otras monedas
              o criptomonedas, con las mejores tasas y comisiones. ✅
            </span>
            <span>
              <span class="font-bold">Retiros continuos sin pérdidas:</span>{" "}
              Aprenderás a retirar tus ganancias de forma continua y sin perder
              dinero por las fluctuaciones del mercado, usando técnicas de
              gestión de capital y diversificación de riesgos. ✅
            </span>
            <span>
              <span class="font-bold">Toma de ganancias:</span> Aprenderás a
              tomar ganancias de forma inteligente, sabiendo cuándo salir de una
              operación, cuánto arriesgar, cuánto ganar, etc. ✅
            </span>
            <span>
              <span class="font-bold">Gestiones de riesgo avanzadas:</span>{" "}
              Aprenderás a gestionar el riesgo de forma avanzada, usando
              herramientas como el stop loss, el take profit, el trailing stop,
              el break even, etc. ✅
            </span>
            <span>
              <span class="font-bold">Comunidad privada:</span> Acceso a una
              comunidad privada donde podrás interactuar con otros alumnos,
              compartir experiencias, resolver dudas, recibir apoyo, etc. ✅
            </span>
            <span>
              <span class="font-bold">
                Gestión de dinero en diversas cuentas:
              </span>{" "}
              Aprenderás a gestionar tu dinero en diversas cuentas, usando
              diferentes brokers, plataformas, monedas, criptomonedas, etc. Así
              podrás aprovechar las mejores oportunidades y reducir el riesgo de
              perder todo tu capital. ✅
            </span>
            <span>
              <span class="font-bold">Libros Exclusivos:</span> Acceso a algunos
              libros digitales que contienen información y consejos sobre las
              opciones binarias y el trading en general, con un enfoque más
              avanzado y profesional. ✅
            </span>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Clases2;
